<template>
<div class="chapter">
<div class="inner_page">
<p class="sp1" id="fm"> </p>
<p class="Chap-Title-ct"><span href="#/xhtml/contents#fm_R" title="Link target outside of Sample">F<span class="ePub-SC">ROM</span> <span class="ePub-SC">THE</span> D<span class="ePub-SC">ESK</span> <span class="ePub-SC">OF</span> S<span class="ePub-SC">OPHIE</span> C<span class="ePub-SC">ASS</span></span></p>
<p class="Dateline-Chapter-dl"> </p>
<p class="Letter-Ext-Dateline-ldl"><span class="ePub-I">New York</span></p>
<p class="Letter-Ext-Dateline-ldl"><span class="ePub-I">August 28, 2000</span></p>
<p class="Letter-Ext-Salutation-lsa"><span class="ePub-I">Dear Mr. Lambert,</span></p>
<p class="Letter-Ext-Body-Text-ltx"><span class="ePub-I">Here’s the thing. You can ignore my letters if you wish, but my piece will run in</span> The New York Times<span class="ePub-I"> whether you, or your lawyers, like it or not. If it weren’t for our family connection, I’d sue you in a heartbeat. I don’t like threats. I am a professional investigative journalist, Mr. Lambert, and I’m just doing my job. This is not some personal vendetta as you claim, nor have I used underhand tactics. As an artist, I’m sure you appreciate the key is to look, to listen clearly, and see the things that other people miss. I looked, and I saw the truth—plain and simple.</span></p>
<p class="Letter-Ext-Body-Text-ltx"><span class="ePub-I">My sources are rock solid, and more importantly I have new evidence for my claims. You see, I have discovered photographs, Mr. Lambert, taken by Alistair Quimby in 1940, the summer before you met Varian Fry in Marseille. Not only are there stunning photos of my great-aunt Vita, there are photos of you at work in the studio at the Château d’Oc. Both of you. I assume I don’t need to explain any more?</span></p>
<p class="Letter-Ext-Body-Text-ltx"><span class="ePub-I">Your lawyers have done their damnedest to warn me off, but now I am warning you—this piece celebrating your illustrious career and 95th birthday will run. I’m going to give you one last chance to put your side of the story before I file my copy. I will come and see you after Labor Day, at midday on Thursday, September 7. I imagine now you’ll be ready to talk.</span></p>
<p class="Letter-Ext-Closing-lcl"><span class="ePub-I">Yours,</span></p>
<p class="Letter-Ext-Closing-lcl"><span class="ePub-I">Sophie Cass</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm.vue?79794f16